import { Component } from 'react';

import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { MarkdownService } from '../../services/markdown.service';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { UIContext } from '../../services/ui-context';
import { RouteProps } from '../../types/route-types';
import MotiveFrame from '../motive-frames/motive-frame.component';
import styles from './faq-pages.component.module.scss';


export default class FAQPageComponent extends Component<RouteProps> {
    public htmlString;
    private sub;

    @lazyInject(PageDataProviderService) private pageDataService: PageDataProviderService;
    @lazyInject(MarkdownService) private markdownService: MarkdownService;
    @lazyInject(UIContext) private uiContext: UIContext;

    constructor(props) {
        super(props);
        this.htmlString = props.markdownHtml;
    }

    render() {
        return <MotiveFrame>
            <div className={styles['wrapper']}>
                <div className={styles['main-card']}>
                    {
                        this.htmlString && <div className={styles['content']} dangerouslySetInnerHTML={{ __html: this.htmlString }}></div>
                    }
                </div>
            </div>
        </MotiveFrame>
    }
}
